// SEO landing pages ("guides") — every entry must be reachable from the
// homepage #guides section and the footer Guides column so Google never
// treats these routes as sitemap-only orphans. Keep in sync with the
// "SEO landing pages" block in src/router/index.js.
// Labels are English data content (these pages are English-primary by design).
export const GUIDES = [
  { path: '/receipt-scanner', label: 'Free receipt scanner' },
  { path: '/receipt-scanner-app', label: 'Receipt scanner app' },
  { path: '/how-to-organize-receipts', label: 'How to organize receipts' },
  { path: '/scan-receipts-and-organize', label: 'Scan receipts and organize them' },
  { path: '/invoice-ocr', label: 'Invoice OCR' },
  { path: '/intelligent-character-recognition', label: 'ICR vs OCR explained' },
  { path: '/pdf-to-excel', label: 'PDF to Excel' },
  { path: '/pdf-to-csv', label: 'PDF to CSV' },
  { path: '/how-to-save-pdf-as-excel', label: 'How to save a PDF as Excel' },
  { path: '/how-to-convert-pdf-form-to-excel', label: 'Convert a PDF form to Excel' },
]
